import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';

@Injectable({
  providedIn: 'root'
})
export class BaseRequestService {

  constructor(private http:HttpServices) { }

  getBaseRequest(id){
    return this.http.get('BaseRequest/GetBaseRequest/'+id);
  }
  GetWithFeesEstimation(id){
    return this.http.get('BaseRequest/GetWithFeesEstimation/'+id);
  }
  getBaseUser(id){
    return this.http.get('BaseRequest/GetBaseUser/'+id);
  }
  getByRequestorId(RequestorId:string, serviceId){
    return this.http.get('BaseRequest/GetByRequestorId?RequestorId='+RequestorId+"&serviceId="+ serviceId);
  }

  getServiceIdByRequestId(id) {
    return this.http.get('BaseRequest/GetServiceIdByRequestId/'+id);
  }

  GetByParentRequestId(id,serviceId){
    return this.http.get('BaseRequest/GetByParentRequestId?id='+id+"&serviceId="+ serviceId);
  }
  GetLastCreatedByUserId(RequestorId:string, serviceId){
    return this.http.get('BaseRequest/GetLastCreatedByUserId?RequestorId='+RequestorId+"&serviceId="+ serviceId);
  }
  GetLastCreatedIdByUserId(RequestorId:string, serviceId){
    return this.http.get('BaseRequest/GetLastCreatedIdByUserId?RequestorId='+RequestorId+"&serviceId="+ serviceId);
  }
}
